import { COMPONENTS } from '../../../components/components.registry';
import { NextQueriesSuggestionsConfig } from '../../../models';

export const DEFAULT_NEXT_QUERIES_SUGGESTIONS_CONFIG: NextQueriesSuggestionsConfig = {
  components: {
    container: COMPONENTS.PURE.Suggestions,
    item: COMPONENTS.PURE.NextQuerySuggestion,
    icon: null
  },
  filterBySessionQueryHistory: true,
  size: 10
};
